import asyncComponent from '../component/asyncComponent'

export default [
    {
        name: "scheme",
        route: "/scheme/:provider/:serialNumber/:path",
        component: asyncComponent(() => import('../pages/scheme')),
    },
    {
        name: "percentile-home",
        route: "/percentile",
        component: asyncComponent(() => import('../pages/percentile/home')),
    },
    {
        name: "doraemon-login",
        route: "/doraemon-login",
        component: asyncComponent(() => import('../pages/doraemon-login')),
    },
    {
        name: "wxtz",
        route: "/wxtz",
        component: asyncComponent(() => import('../pages/wxtz')),
    },
    {
        name: "weChatPay",
        route: "/weChatPay",
        component: asyncComponent(() => import('../pages/weChatPay')),
    },
    {
        name: "dietitian",
        route: "/talkcat/dietitian",
        component: asyncComponent(() => import('../pages/talkcat/dietitian')),
    },
    {
        name: "partners",
        route: "/talkcat/partners",
        component: asyncComponent(() => import('../pages/talkcat/partners')),
    },
    {
        name: "yongXinPay",
        route: "/yongXinPay",
        component: asyncComponent(() => import('../pages/yongXinPay')),
    }
]